module.exports = __webpack_public_path__ + "static/media/glass-champagne.9f5e44b9.svg";